<template>
  <div id="app" class="gap-font-style h-100">
    <div ref="ad-block-detector">
      <div class="adBanner">
      </div>
    </div>
    <router-view v-if = "!isAdBlocked" />
    <b-modal id="ad-blocked-modal"
             title="광고 차단됨"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close
             centered
             ok-only
             ok-title="무시하고 계속 이용"
             ok-variant="danger"
             @ok="ignore">
      광고 관련 기능들이 차단되어서 광고주센터가 제대로 동작하지 않습니다.<br>
      Ad Block등 광고 차단 프로그램을 정지하신 뒤 광고주센터를 이용하실 수 있습니다.<br>
      정지 후 새로고침 부탁드립니다.
    </b-modal>

    <b-modal id="modal-notice" title="공지사항"
             :ok-only="true"
             centered
             ok-title="닫기"
             size="lg"
             @show="noticeListInit"
             scrollable>
      <b-card ref="noticeList" body-class="p-0 pl-1 pr-1">
        <gap-table class="mt-3"
                   sort-by="name"
                   sort-compare-locale="kr"
                   :show-empty="true"
                   :fields="fields"
                   :items="notices">
          <template v-slot:cell(manage)="data">
            <span @click="showNoticeDetail(data)" style="cursor:pointer;">{{data.item.title}}</span>
          </template>
        </gap-table>
      </b-card>
      <!--TODO:UI 깔끔하게 개선 -->
      <b-card ref="noticeView" style="display: none">
        <b-card-header>
          <span ref="noticeTitle"></span>(<span ref="noticeDate"></span>)
        </b-card-header>
        <b-card-body>
          <div ref="noticeContent"></div>
        </b-card-body>
        <b-card-footer>
          <b-button size="sm" variant="outline-gray" @click="showNoticeList()">
            목록으로
          </b-button>
        </b-card-footer>
      </b-card>

    </b-modal>
  </div>
</template>

<script>
  import GapTable from "@/components/general/GapTable";
  import axios from "axios";
  import {mapGetters} from 'vuex';


  export default {
    name: 'App',
    components: {GapTable},
    data() {
      return {
        isAdBlocked: false,
        fields: [
          {key: "manage", label: "제목", thClass: "text-nowrap", class: "text-nowrap"},
          {key: "begin_time", label: "날짜", formatter: val => val.split('T')[0], thStyle: "width:150px"}
        ],
        notices: [],
        httpClient : null
      };
    },
    mounted() {
      if (this.$refs['ad-block-detector']?.clientHeight === 0) {
        this.$bvModal.show('ad-blocked-modal');
        this.isAdBlocked = true;
      }
    },
    computed: {
    },
    methods: {
      ignore() {
        this.isAdBlocked = false;
      },
      showNoticeDetail(data) {
        this.httpClient.get("/web-data-cdn/" + data.item.file_path).then(
          response => {
            this.$refs['noticeTitle'].innerHTML = response.data.title;
            this.$refs['noticeDate'].innerHTML = this.formatDate(response.data.date);
            this.$refs['noticeContent'].innerHTML = this.decode(response.data.content);
            this.$refs['noticeList'].style.display = 'none'
            this.$refs['noticeView'].style.display = 'block'
          }
        );
      },
      showNoticeList() {
        this.$refs['noticeList'].style.display = 'block';
        this.$refs['noticeView'].style.display = 'none';
      },
      decode(str) {
        return decodeURIComponent(atob(str).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
      },
      formatDate(date) {
        var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;
        return [year, month, day].join('-');
      },
      noticeListInit() {
        this.httpClient = axios.create(
          {
            baseURL: window.location.origin,
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              Pragma: 'no-cache'
            }
          }
        );
        this.httpClient.get("/web-api?appId=GAP1&country=kr&lang=ko&market=pc&type=notice").then(
          response => {
            this.notices = response.data.noticeList;
          }
        );
      }
    }
  }
</script>

<style>
  .adBanner {
    background-color: transparent;
    height: 1px;
    width: 1px;
  }
</style>
